import ContainerMaxWidthXl from '@deltek/specification-client/core/Surfaces/ContainerMaxWidthXl'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { AppBar } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import ProjectTopTabNav from 'pages/ProjectsPage/components/ProjectTopTabNav'
import React from 'react'
import {
    HARMONY_PANEL_HEIGHT,
    useHarmonyPanelStyles,
} from 'shared/hooks/useHarmonyPanelStyles'
import useIsHarmonyHeader from 'shared/hooks/useIsHarmonyHeader'

/** Height of this panel in the classic (non-Harmony) header, in pixels. */
export const CLASSIC_PANEL_HEIGHT = 100

const useStyles = makeStyles((theme: Theme) => ({
    enterAnimate: {
        height: 0,
    },
    entered: {
        height: CLASSIC_PANEL_HEIGHT,
        borderBottom: `1px solid ${theme.palette.common.white}`,
    },
    actionBar: {
        background: theme.palette.grey[700],
        padding: theme.spacing(0, 3),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    enteredLight: {
        height: pxToRem(HARMONY_PANEL_HEIGHT),
        paddingTop: theme.harmony.spacing.sm,
        paddingBottom: theme.harmony.spacing.sm,
        borderBottom: `1px solid ${theme.harmony.colors.strokeWeak}`,
    },
}))

export interface ProjectPagePartialNavBarMenuProps {
    showExport?: VoidFunction
    /** Set by AppHeader to animate this panel open/closed. */
    isOpen?: boolean
}

const ProjectPagePartialNavBarMenu: React.FC<ProjectPagePartialNavBarMenuProps> = ({
    showExport,
    isOpen = true,
}) => {
    const classes = useStyles()
    const harmonyClasses = useHarmonyPanelStyles()
    const isHarmonyHeader = useIsHarmonyHeader()

    return (
        <AppBar
            elevation={0}
            position="relative"
            className={clsx(
                'navBarMenu',
                classes.actionBar,
                isHarmonyHeader && harmonyClasses.panelLight,
                !isOpen && classes.enterAnimate,
                isOpen &&
                    (isHarmonyHeader ? classes.enteredLight : classes.entered)
            )}
        >
            <ContainerMaxWidthXl>
                <ProjectTopTabNav
                    expandToHorizontalSpace
                    useBiggerTabs={!isHarmonyHeader}
                    showExport={showExport}
                />
            </ContainerMaxWidthXl>
        </AppBar>
    )
}

export default ProjectPagePartialNavBarMenu
